import { UseDuctedComponentSwapResult } from 'hooks/use-ducted-component-swap';
import { DUCTED_SWAP_SLOT_SUBJECTS } from 'utils/ducted-component-swap';
import { DuctedSwapSlot } from 'utils/ducted-component-swap-types';
import { LockToggleButton } from './condenser-component-rows';
import SwapProductPopover from './swap-product-popover';

type DuctedSlotActionsProps = Readonly<{
  slot: DuctedSwapSlot;
  currentPrice: number;
  swapModel: UseDuctedComponentSwapResult;
  isLoading: boolean;
}>;

export default function DuctedSlotActions({
  slot,
  currentPrice,
  swapModel,
  isLoading
}: DuctedSlotActionsProps) {
  const subject = DUCTED_SWAP_SLOT_SUBJECTS[slot];
  return (
    <>
      <SwapProductPopover
        variant='ducted'
        slot={slot}
        products={swapModel.options[slot]}
        currentPrice={currentPrice}
        onSelect={(modelKey) => swapModel.swap(slot, modelKey)}
        hasActiveLocks={swapModel.hasOtherLocks(slot)}
        isLoading={isLoading}
        tooltipText={`Change ${subject}`}
      />
      <LockToggleButton
        locked={swapModel.locks[slot]}
        subject={subject}
        onToggle={() => swapModel.toggleLock(slot)}
      />
    </>
  );
}
